import { render } from "./MisPreciosComponent.vue?vue&type=template&id=2e2df480&scoped=true"
import script from "./MisPreciosComponent.vue?vue&type=script&lang=js"
export * from "./MisPreciosComponent.vue?vue&type=script&lang=js"

import "./MisPreciosComponent.vue?vue&type=style&index=0&id=2e2df480&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2df480"]])

export default __exports__